<ul>
    <li>Le mot de passe doit contenir :</li>
    <li>
        <span>au moins 14 caractères</span>
        <kal-icon *ngIf="!errors?.passwordMinLength" class="gup-U-color--green">check</kal-icon>
    </li>
    <li>
        <span>au moins une majuscule</span>
        <kal-icon *ngIf="!errors?.passwordNeedUppercaseLetter" class="gup-U-color--green">check</kal-icon>
    </li>
    <li>
        <span>au moins une minuscule</span>
        <kal-icon *ngIf="!errors?.passwordNeedLowercaseLetter" class="gup-U-color--green">check</kal-icon>
    </li>
    <li>
        <span>au moins un chiffre</span>
        <kal-icon *ngIf="!errors?.passwordNeedNumber" class="gup-U-color--green">check</kal-icon>
    </li>
    <li>
        <span>au moins un caractère spécial</span>
        <kal-icon *ngIf="!errors?.passwordNoSpecialCharacter" class="gup-U-color--green">check</kal-icon>
    </li>
</ul>
